// src/themes/styles/features.ts
import { CSSProperties } from "react";
import { ColorTheme } from "../colors";

export const getFeaturesStyles = (
  theme: ColorTheme
): { [key: string]: CSSProperties } => ({
  features: {
    padding: "5rem 1rem",
    background: theme.featuresGradient,
  },

  featuresContainer: {
    maxWidth: "1280px",
    margin: "0 auto",
  },

  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "2rem",
  },

  featureCard: {
    background: theme.cardBackground,
    height: "100%",
    padding: "1.9rem",
    borderRadius: "22px",
    border: `1px solid ${theme.cardBorder}`,
    boxShadow: "0 4px 20px rgba(7, 9, 26, 0.05)",
    transition: "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.35s ease, border-color 0.35s ease",
    cursor: "default",
    position: "relative" as const,
    overflow: "hidden" as const,
  },

  featureIcon: {
    width: "56px",
    height: "56px",
    background: theme.primaryGradient,
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    marginBottom: "1.4rem",
    transition: "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)",
    boxShadow: `0 8px 20px ${theme.primaryGlow}`,
  },

  featureTitle: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: theme.textPrimary,
    marginBottom: "0.75rem",
    letterSpacing: "-0.01em",
  },

  featureDesc: {
    color: theme.textSecondary,
    lineHeight: 1.65,
    fontSize: "0.98rem",
  },

  // MOBILE STYLES
  mobileFeatures: {
    width: "100%",
    padding: "3rem 0",
  },

  mobileFeaturesGrid: {
    gridTemplateColumns: "1fr",
    gap: "1.5rem",
    maxWidth: "400px",
    margin: "0 auto",
  },

  mobileFeatureCard: {
    padding: "1.5rem",
    textAlign: "center" as const,
  },

  mobileFeatureIcon: {
    width: "48px",
    height: "48px",
    margin: "0 auto 1rem auto",
  },

  mobileFeatureTitle: {
    fontSize: "1.125rem",
    marginBottom: "0.75rem",
  },

  mobileFeatureDesc: {
    fontSize: "0.95rem",
    lineHeight: 1.5,
  },
});
